import React from 'react';
import Card from '@material-ui/core/Card';
import Icon from '@material-ui/core/Icon';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
		root: {
			paddingLeft: 30,
			paddingRight: 10,
			borderLeft: '3px solid #F9A51A',
			borderRadius: 0
  		},
  		wrapper: {
  			display: 'flex',
  		},
		details: {
			display: 'flex',
			flexDirection: 'column',
		},
		content: {
			flex: '1 0 auto',
		},
		imageIcon: {
			width: 37,
			height: 70
		},
		titleText3: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 500,
			letterSpacing: 0,
			textAlign: 'left',
			marginBottom: 5
		},
		valueText3: {
			color: '#333333',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 600,
			letterSpacing: 0,
			textAlign: 'left'
		},
		titleText2: {
			color: '#2F394A',
			fontFamily: 'Graphik',
			fontSize: 16,
			fontWeight: 600,
			letterSpacing: 0,
			textAlign: 'left'
		},
		valueText2: {
			color: '#333333',
			fontFamily: 'Graphik',
			fontSize: 14,
			fontWeight: 300,
			letterSpacing: 0,
			textAlign: 'left'
		},
		 expand: {
    		transform: 'rotate(0deg)',
            marginLeft: '45px',
            fontSize: '.9em',
            color: '#005383',
            fontWeight: 800,
            textTransform: 'uppercase',
            cursor: 'pointer',
    		transition: theme.transitions.create('transform', {
      			duration: theme.transitions.duration.shortest,
    		}),
  		},
        upArrow: {
            transform: 'rotate(-90deg)',
            display: 'inline-block'
        },
        downArrow: {
            transform: 'rotate(90deg)',
            display: 'inline-block'
        },
        subSchool: {
            paddingLeft: '53px',
            paddingTop: '8px',
            fontSize: '1.2em'
        },
        cardItem: {
            paddingBottom: '10px',
            fontWeight: '600',
            "&:last-child": {
                paddingBottom: '0'
            }
        },
        cardEqualHeight: {
            width: '100%', 
            display: 'flex', 
            justifyContent: 'space-between', 
            flexDirection: 'column'
        }
	})
);

function CardIcon({ imageURL, title, classes }) {
	if (!imageURL) {
    	return null;
	}
 
	return (
		<Icon className={classes.imageIcon}>
				<img alt={title} className={classes.imageIcon} src={imageURL}/>
		</Icon>
	);
}

function getTitleClass(classes, imageURL) {
	return ((undefined === imageURL) ? classes.titleText2:classes.titleText3 );
}

function getValueClass(classes, imageURL) {
	return ((undefined === imageURL) ? classes.valueText2:classes.valueText3 );
}

const HorizontalIconCard = ( { imageURL, title, values, expand, schoolExpanded } ) => {
	const classes = useStyles();
	const [expanded, setExpanded] = React.useState(false);

  	const handleExpandClick = () => {
    	setExpanded(!expanded);
  	};

	return (
		<Card className={`${classes.root} ${classes.cardEqualHeight}`} variant="outlined" key={title}>
			<div className={classes.wrapper}>
				<CardIcon imageURL={imageURL} classes={classes} title={title} />
				<div className={classes.details}>
						<CardContent className={title === 'EDUCATION' ? classes.content : null}>
						<Typography className={getTitleClass(classes, imageURL)}>
							{title}
						</Typography>
						{values.map((value, index) => (
							<Typography key={index} className={`${getValueClass(classes, imageURL)} ${classes.cardItem}`}>
								{value}
							</Typography>
						))}
						</CardContent>
				</div>
			</div>
            { expand && schoolExpanded.length > 0?
                <>
          		<Collapse in={expanded} timeout="auto" unmountOnExit expand={true.toString()}>
            		<CardContent className={classes.subSchool}>
              			{schoolExpanded.map((value, index) => (
                            <Typography key={index} className={`${getValueClass(classes, imageURL)} ${classes.cardItem}`}>
                                {value}
                            </Typography>
                        ))}
            		</CardContent>
          		</Collapse>
                <CardActions disableSpacing>
                    <div
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                    { !expanded ? <>See More <span className={classes.downArrow}>&gt;</span></> : <>See Less <span className={classes.upArrow}>&gt;</span></> }

                    </div>
                </CardActions>
                </>
            : null}
		</Card>
	);
}

export default HorizontalIconCard;
